import { render, staticRenderFns } from "./industryTop.vue?vue&type=template&id=4a9dcb57&scoped=true"
import script from "./industryTop.vue?vue&type=script&lang=js"
export * from "./industryTop.vue?vue&type=script&lang=js"
import style0 from "./industryTop.vue?vue&type=style&index=0&id=4a9dcb57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dcb57",
  null
  
)

export default component.exports